import { Box, Tab, Tabs } from "@mui/material";
import { useState, useEffect } from "react";
import { LayoutBaseDePagina } from "../../../shared/layouts";
import { TabQuote } from "./tabs/tabQuote";
import { TabPolices } from "./tabs/tabPolices";
import { TabFireFinancial } from "./tabs/tabFireFinancial";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../shared/enums/profiles";

export const FirePresentation = () => {
	const [selectedTab, setSelectedTab] = useState<number | false>(false);

	// Permission Checks
	const canViewQuotes = checkByProfileGuard(
		PermissionRolesEnum.FireOptions,
		PermissionActionsEnum.View,
	);

	const canViewPolicies = checkByProfileGuard(
		PermissionRolesEnum.FirePolicesOptions,
		PermissionActionsEnum.View,
	);

	const canViewFinancial = checkByProfileGuard(
		PermissionRolesEnum.FireFinancialOptions,
		PermissionActionsEnum.View,
	);

	// Determine initial tab based on permissions
	useEffect(() => {
		if (canViewQuotes) {
			setSelectedTab(0);
		} else if (canViewPolicies) {
			setSelectedTab(1);
		} else if (canViewFinancial) {
			setSelectedTab(2);
		} else {
			setSelectedTab(false);
		}
	}, [canViewQuotes, canViewPolicies, canViewFinancial]);

	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setSelectedTab(newValue);
	};

	return (
		<LayoutBaseDePagina
			titulo="Seguro Incêndio"
			subtitulo="Gestão de Seguro Incêndio"
			barraDeFerramentas={<></>} // A barra de ferramentas agora está DENTRO da aba
		>
			<Tabs
				value={selectedTab}
				onChange={handleTabChange}
				aria-label="Gestão de Seguro Incêndio"
				sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "background.paper", mx: 1, borderRadius: 1, bordercolor: "divider" }}
			>
				{canViewQuotes && <Tab label="Orçamentos" value={0} />}
				{canViewPolicies && <Tab label="Apólices" value={1} />}
				{canViewFinancial && <Tab label="Financeiro" value={2} />}
			</Tabs>

			<Box sx={{ pt: 1 }}>
				{selectedTab === 0 && canViewQuotes && <TabQuote />}
				{selectedTab === 1 && canViewPolicies && <TabPolices />}
				{selectedTab === 2 && canViewFinancial && <TabFireFinancial />}
			</Box>
		</LayoutBaseDePagina>
	);
};


